export default new Set(["REBATE", "TAX CREDIT", "TAX EXEMPTION"]);